import { useTranslation } from "react-i18next";

import { styled } from "simplydo/react/styled";

const Text = styled.div`
  display: flex;
  flex-direction: column;
`;

const Row = styled.div``;

const Code = styled.span`
  background-color: #f3f3f3;
  border-radius: 2px;
  padding: 0px 3px 1px 3px;
`;

export const Help = () => {
  const { t } = useTranslation();
  return (
    <Text>
      <Row>Try out some of these shortcuts to add extra context.</Row>
      <Row>
        Enter
        <Code>@</Code> to mention a user. (e.g.
        <Code>@Jane Doe</Code>)
      </Row>
      <Row>
        Enter
        <Code>$</Code> to mention {t("generic.ideaWithArticle")},{" "}
        {t("generic.group")} or {t("generic.challenge")}. (e.g.
        <Code>$Save the world</Code>)
      </Row>
      <Row>
        Enter
        <Code>:</Code> to search through a list of emojis. (e.g.
        <Code>:fire:</Code> turns into 🔥)
      </Row>
    </Text>
  );
};
